import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/close-icon.png'


import Captcha from './captcha.vue'
import { onUnmounted, ref } from 'vue'
import { captchaCheckService } from '@/common/basis/root-injector'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'captcha-dialog',
  setup(__props) {

const changeVisibleSubscribe = captchaCheckService.onChangeVisible.subscribe((response) => {
  console.log('visible.value response', response)
  visible.value = response
})

const visible = ref(false)

function handleCancel () {
  captchaCheckService.changeVisible(false)
  captchaCheckService.checkReject(new Error('已取消验证'))
  ElMessage.warning('已取消验证')
}

function handleConfirm(value) {
  captchaCheckService.captchaCode = value
  captchaCheckService.checkResolve(true)
  captchaCheckService.changeVisible(false)
}

onUnmounted(() => {
  changeVisibleSubscribe.unsubscribe()
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    "custom-class": "captcha-dialog-wrap captcha-dialog",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    title: "人机校验",
    center: true,
    "close-on-click-modal": false,
    "show-close": false,
    width: "390px"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        class: "close-icon",
        src: _imports_0,
        alt: "",
        onClick: handleCancel
      }),
      _createVNode(Captcha, {
        visible: visible.value,
        onConfirm: handleConfirm
      }, null, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})